.root {
  height: 100%;
  transform: translateZ(0); // to make buttons clickable on details panel

  &.roleDetail {
    z-index: 99999999;
  }
}

.subtitle {
  color: var(--paletteBlue2);
}

.title {
  font-weight: 400;
  font-size: 17px;
  line-height: 21px;
  color: var(--paletteBlue0);
  border-bottom: 2px solid var(--paletteNeutral1);
  padding-bottom: 5px;
  margin-bottom: 10px;

  .name {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.spaceBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.duration {
  .label,
  .text {
    margin-right: 5px;
    margin-bottom: -3px;
  }

  .availabilityTooltip {
    max-height: 200px;
    overflow: auto;
  }
}

.alignCenter {
  display: flex;
  align-items: center;
}

.details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacingXl) var(--spacingLg);

  .icon {
    margin-right: 10px;
    height: 20px;
    width: 20px;
  }
}

.detailsRole {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);

  .icon {
    margin-right: 10px;
    height: 20px;
    width: 20px;
  }
}

.allDeleteButtons {
  flex-direction: column;
}

.buttons {
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  gap: 5px;
  justify-content: end;
}

.wideButton {
  width: 100%;
}

.icon {
  fill: var(--paletteBlue0);
}

.bookingCategory {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bookingCategoryPill {
  height: 24px;
  width: 172px;
  min-width: 80px;
}

.footer {
  flex-grow: 1;
  display: flex;
  align-items: flex-end;
}

.buttonsLoader {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressBar {
  margin-top: 12px;
}

.auditActivityIcon {
  &Container {
    margin-left: 4px;
    margin-top: 2px;
  }

  &Badge {
    top: -2px;
    left: -4px;
    width: 16px;
    height: 16px;

    svg {
      fill: var(--paletteWhite0);
    }
  }

  &BadgeSmall {
    width: 10px;
    height: 10px;
  }
}

.activityName {
  white-space: normal;
  text-align: left;
  max-width: 300px;
}

.activityLink {
  display: flex;
}

.detailItem {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}

.carouselHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingXl);
}

.item {
  display: flex;
  flex-direction: column;
}

.itemSpanRow {
  grid-column: span 2;
}

.workforceMemberButton {
  white-space: normal;
  text-align: left;
}

.actionableContainer {
  padding: var(--spacingMd);
  background: var(--paletteNeutral2);
  border-radius: var(--radiusMd);
}
